// apps/web/src/components/MicrosList.tsx
import { useT, useLocale } from "../lib/i18n";
import { MICRO_KEYS } from "@shared/micros";
import type { Micros } from "@shared/micros";

// Informational daily totals for vitamins & minerals — no targets. Renders
// nothing when there is no micro data. Order follows the MICRO_KEYS registry.
export function MicrosList({ micros }: { micros: Micros }) {
  const t = useT();
  const { locale } = useLocale();
  const rows = MICRO_KEYS
    .map((d) => ({ d, v: micros[d.key] }))
    .filter((r) => typeof r.v === "number" && r.v > 0);
  if (rows.length === 0) return null;
  return (
    <div className="mt-4">
      <div className="text-sm text-fg-muted uppercase tracking-wider mb-2">
        {t("micros.title")}
      </div>
      <div className="grid grid-cols-2 gap-x-4 gap-y-1">
        {rows.map(({ d, v }) => (
          <div key={d.key} className="flex justify-between text-sm">
            <span className="text-fg-secondary truncate">{locale === "de" ? d.label_de : d.label_en}</span>
            <span className="tabular-nums text-fg-muted">{Math.round(v! * 10) / 10} {d.unit}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
